/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface INetworkNodeModemAdapter {
        href: string;
        slot: number;
        imei: number;
        networkNode: Models.INetworkNode;
    }

    export interface INetworkNodeModem {
        href: string;
        slot: number;
        imei: number;
        networkNode: number;
    }

    export class NetworkNodeModemAdapter implements INetworkNodeModemAdapter {
        public href: string;
        public slot: number;
        public imei: number;
        public networkNode: Models.INetworkNode;

        constructor() {
            // empty constructor
            this.href = '';
        }
    }

    export class NetworkNodeModem implements INetworkNodeModem {
        public href: string;
        public slot: number;
        public imei: number;
        public networkNode: number;

        public static Empty(): NetworkNodeModem {
            return new NetworkNodeModem();
        }

        public static Copy(networkNodeModem: INetworkNodeModem): NetworkNodeModem {
            let newNetworkNodeModem: INetworkNodeModem = new NetworkNodeModem();
            newNetworkNodeModem.href = networkNodeModem.href;
            newNetworkNodeModem.slot = networkNodeModem.slot;
            newNetworkNodeModem.imei = networkNodeModem.imei;
            newNetworkNodeModem.networkNode = networkNodeModem.networkNode;
            return newNetworkNodeModem;
        }

        constructor() {
            // empty constructor
            this.href = '';
        }
    }
}